// Title
const NEWS_ARTICLES = [
  // 31 Oct. 2020
  {
    "key": 6,
    "image":"https://images.yourstory.com/cs/2/4c455a90a21411e98b07315772315642/FreshokartzPlaceholderFotor1572362671238png?fm=png&auto=format&ar=2:1&mode=crop&crop=face",
    "title": "Agritech startup FreshoKartz helps augment farmers’ income by 50 pc",
    "headline": "Founded in 2016 by Rajendra Lora, FreshoKartz's data-driven approach makes the agritech startup unique.The team analyses a farmer’s past crop history and soil data, after which it recommends seeds, pesticides, and fertilisers that should be used to increase yield.",
    "link": "https://yourstory.com/2019/10/tech30-startup-agritech-freshokartz-farmers-income",
    "medianame": "Your Story",
    "medialogo":"https://yourstory.com/logos/logo_yourstory.svg"
  },
  // 28 Oct. 2020
  {
    "key": 5,
    "image":"https://assets.entrepreneur.com/content/3x2/2000/1603904455-freshoedit.jpg",
    "title": "Agritech Startup Freshokartz Picks INR 10 Cr in Pre-series A Funding to Expand Beyond Rajasthan",
    "headline": "FreshoKartz pre-series A funding round was led by Rajasthan Venture Capital Fund (RVCF) and AWE (Achieving Women Equity) Funds",
    "link": "https://www.entrepreneur.com/article/358670",
    "medianame": "Entrepreneur",
    "medialogo":"https://assets.entrepreneur.com/static/1413842503-entrepreneur-logo.png"
  },  
  // 28 Oct. 2020
  {
    "key": 8,
    "image":"https://images.yourstory.com/cs/2/b87effd06a6611e9ad333f8a4777438f/Imagenxrk-1603860958964.jpg",
    "title": "[Funding alert] Agritech startup Freshokartz raises Rs 10 Cr in Pre-Series A from RVCF, AWE Funds",
    "headline": "The agritech startup will be using the funds for expansion within Rajasthan and other nearby states like Haryana, Madhya Pradesh, Uttar Pradesh, and other northern states of India.",
    "link": "https://yourstory.com/2020/10/funding-alert-agritech-startup-freshokartz-rvcf-awe-funds",
    "medianame": "Your Story",
    "medialogo":"https://yourstory.com/logos/logo_yourstory.svg"
  },
  // 24 July 2020
  {
    "key": 4,
    "image":"https://static.toiimg.com/photo/47529300.cms",
    "title": "Freshokartz Fund Expansion",
    "headline": "Freshokartz looks to raise $2mn to fund expansion",
    "link": "https://timesofindia.indiatimes.com/city/jaipur/freshokartz-looks-to-raise-2mn-to-fund-expansion/articleshow/77140075.cms",
    "medianame": "The Time of India",
    "medialogo":"https://static.toiimg.com/photo/47529300.cms"
  },
  // June 28, 2020
  {
    "key": 1,
    "image":"https://images.indianexpress.com/2020/06/759-8.jpg",
    "title": "How Freshokartz is using Whatsapp for Business",
    "headline": "Locksown forces small Indian companies to look big time at WhatsApp",
    "link": "https://indianexpress.com/article/technology/tech-news-technology/lockdown-forces-small-indian-companies-to-look-big-time-at-whatsapp-6459633/",
    "medianame": "Indian Express",
    "medialogo":"https://indianexpress.com/wp-content/themes/indianexpress/images/indian-express-logo-n.svg"
  },
  // 10 Dec. 2019
  {
    "key": 7,
    "image":"https://cdn.inc42.com/wp-content/uploads/2019/04/freshokartz-rajendra-Feature-1044x783.jpg",
    "title": "Exclusive: With An Eye On Expansion, Freshokartz Raises Pre-Series A Funding",
    "headline": "There are more than 1,090 agritech startups in India and according to Datalabs by Inc42, the total funding in agritech startups in India grew from $46.1 Mn 2017 to $66.6 Mn in 2018. One of the active players is Jaipur-based Freshokartz. The company is building an integrated solution to support farmers for their end-to-end needs for produce and also enable them to sell the same in the locality. Backed by multiple angel investors and HNIs, the company has now raised fresh funding.",
    "link": "https://inc42.com/buzz/exclusive-with-an-eye-on-expansion-freshokartz-raises-pre-series-a-funding/",
    "medianame": "inc42",
    "medialogo":"https://media.wigzo.com/uploads/7e09360d-cc35-499e-b1ae-4790c938cbed/userimagegallery/2d90a7b3-7418-4075-93dc-00638dc22b8f.png"
  },
  // 12 Oct 2019
  {
    "key": 2,
    "image":"https://images.yourstory.com/cs/2/11718bd02d6d11e9aa979329348d4c3e/Tech3011570876337377png",
    "title": "Freshokartz in Tech 30 High Potenital Startups",
    "headline": "TechSparks 2019: Unveiling Tech30 - YourStory’s list of high-potential tech startups in India",
    "link": "https://yourstory.com/2019/10/techsparks-2019-tech30-startups-entrepreneurs-india",
    "medianame": "YourStory",
    "medialogo":"https://yourstory.com/logos/logo_yourstory.svg"
  },
  // 9 July 2018
  {
    "key": 3,
    "image":"https://cdn.inc42.com/wp-content/uploads/2018/07/bhamashah-techno-fund-01-1.jpg",
    "title": "Freshokartz supported by Bhamashah Techno Fund",
    "headline": "Bhamashah Techno Fund: Meet The 7 Startups Funded By Rajasthan’s Bhamashah Techno Fund",
    "link": "https://inc42.com/features/bhamashah-techno-fund-meet-the-7-startups-funded-by-rajasthans-bhamashah-techno-fund/",
    "medianame": "inc42",
    "medialogo":"https://media.wigzo.com/uploads/7e09360d-cc35-499e-b1ae-4790c938cbed/userimagegallery/2d90a7b3-7418-4075-93dc-00638dc22b8f.png"
  },  
];


export default NEWS_ARTICLES;
